import { useCalculator } from "@/components/sections/calculator/use-calculator";
import CalcControls from "@/components/sections/calculator/CalcControls";
import CalcSummary from "@/components/sections/calculator/CalcSummary";
import CalcGate from "@/components/sections/calculator/CalcGate";

export default function PriceCalculator({ t, lang, scrollTo, onPrefill }) {
  const c = t.calculator;
  const calc = useCalculator(scrollTo, onPrefill);

  return (
    <section id="calculator" className="py-20 sm:py-28" data-testid="calculator-section">
      <div className="max-w-5xl mx-auto px-6 sm:px-10">
        <div className="text-center mb-10">
          <span className="label-eyebrow">{c.label}</span>
          <h2 className="font-heading text-4xl sm:text-5xl mt-3 mb-4">{c.title}</h2>
          <p className="text-lg text-[var(--body)] max-w-2xl mx-auto">{c.subtitle}</p>
        </div>

        {!calc.unlocked ? (
          <CalcGate g={c.gate} lang={lang} onUnlock={calc.unlock} />
        ) : (
          <div className="card-surface p-6 sm:p-10 grid grid-cols-1 lg:grid-cols-2 gap-8 reveal">
            <CalcControls c={c} state={calc.state} actions={calc.actions} />
            <CalcSummary t={t} result={calc.result} onBook={calc.handleBookClick} />
          </div>
        )}
      </div>
    </section>
  );
}
